export default __webpack_public_path__ + "static/media/nav-burger-icon-black.d0e3b692.svg";